/**
* Created by vouill on 4/19/18.
*/

<template>
  <div class="v-container-k">
    <ArticleListItem
      v-if="articleList"
      v-for="(article, index ) in articleList"
      :article="article"
      :key="index"
      :includes="data.includes"
    />
  </div>
</template>

<style scoped lang="scss">
.v-container-k {
  display: grid;
  grid-template-columns: repeat(auto-fill, 200px);
  grid-column-gap: 25px;
  grid-row-gap: 25px;
  place-content: center;
  @media screen and (max-width: 470px) {
    grid-template-columns: 1fr;
    grid-row-gap: 30px;
    padding: 0 40px;
  }
}
</style>

<script>
import ArticleListItem from "./article-list-item";
export default {
  name: "ArticleList",
  props: { data: Object },
  components: { ArticleListItem },
  computed: {
    articleList() {
      return this.data && this.data.items.slice(1);
    }
  }
};
</script>
